import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { ProjectFragmentDoc } from '../../fragments/__generated__/project';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    
export type CreateProjectMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  status?: Types.InputMaybe<Types.ProjectStatusEnum>;
  sector: Types.Scalars['String']['input'];
  background_base64?: Types.InputMaybe<Types.Scalars['String']['input']>;
  background_info?: Types.InputMaybe<Types.Scalars['String']['input']>;
  schema_base64?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject?: { __typename?: 'Project', id: string, code: string, status?: Types.ProjectStatusEnum | null, sector?: string | null, created_at?: number | null, updated_at?: number | null, name?: string | null, background_info?: string | null, background?: { __typename?: 'File', base64: string, path: string, filename: string, width?: number | null, height?: number | null, type: string, size: number } | null, schema?: { __typename?: 'File', filename: string, path: string } | null, preview?: { __typename?: 'File', filename: string, path: string } | null, user?: { __typename?: 'User', id: string, name?: string | null, city?: string | null, email: string, active: boolean, company?: string | null, is_admin: boolean } | null } | null };


export const CreateProjectDocument = gql`
    mutation CreateProject($name: String!, $status: ProjectStatusEnum, $sector: String!, $background_base64: String, $background_info: String, $schema_base64: String) {
  createProject(
    name: $name
    status: $status
    sector: $sector
    background_base64: $background_base64
    background_info: $background_info
    schema_base64: $schema_base64
  ) {
    ...project
  }
}
    ${ProjectFragmentDoc}`;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      sector: // value for 'sector'
 *      background_base64: // value for 'background_base64'
 *      background_info: // value for 'background_info'
 *      schema_base64: // value for 'schema_base64'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;